import React, {PureComponent} from 'react'

import Button from 'rambler-ui/Button'
import withStyles from 'isomorphic-style-loader/withStyles'

import Logo from 'components/logos/Logo'
import Title from 'components/Title'
import Subtitle from 'components/Subtitle'
import BackLink from 'components/BackLink'

import styles from './styles.module.css'

class Header extends PureComponent {
  render() {
    const {loggedIn, displayName, avatarUrl} = this.props
    const marg = loggedIn ? 'marg' : ''

    return (
      <section className={styles.header}>
        <div className={styles.showcaseDesk}>
          <article className={styles.textBox}>
            <a
              href="https://rambler-co.ru"
              title="RAMBLER&Co"
              target="_top"
              className={styles.logo + ' ' + styles[marg]}>
              <Logo />
            </a>
            <Title>Единый профиль для всех проектов</Title>
            <Subtitle>
              Больше не нужно регистрироваться на каждом сайте — ваш новый
              профиль работает на самых популярных сайтах российского интернета
            </Subtitle>
            {/* Strict check is done to prevent view from blinking */}
            {loggedIn === true ? (
              <div className={styles.social}>
                <img src={avatarUrl} alt="Ваш аватар" />
                <p>
                  Вы авторизованы
                  {displayName && (
                    <span className={styles.newLine}>как {displayName}</span>
                  )}
                </p>
              </div>
            ) : null}
            {/* Strict check is done to prevent view from blinking */}
            {loggedIn === false ? (
              <Button href="#proposal" className={styles.ctaButton} rounded>
                Завести профиль
              </Button>
            ) : null}
            <BackLink />
          </article>
          <div className={styles.showcase} />
        </div>
      </section>
    )
  }
}

export default withStyles(styles)(Header)
